export const industryServicesData = {
  electrical: [
    'Residential Electrical Services',
    'Commercial Electrical Work',
    'Emergency Electrical Repairs',
    'Electrical Panel Upgrades',
    'Lighting Installation',
    'Wiring & Rewiring',
    'Generator Installation',
    'EV Charger Installation'
  ],
  hvac: [
    'AC Installation & Repair',
    'Heating System Services',
    'Duct Cleaning & Repair',
    'HVAC Maintenance Plans',
    'Indoor Air Quality Solutions',
    'Thermostat Installation',
    'Emergency HVAC Services',
    'Energy Efficiency Upgrades'
  ],
  landscaping: [
    'Landscape Design',
    'Lawn Maintenance',
    'Hardscaping Services',
    'Irrigation Systems',
    'Tree & Shrub Care',
    'Seasonal Cleanup',
    'Outdoor Lighting',
    'Landscape Renovation'
  ],
  pestControl: [
    'Residential Pest Control',
    'Commercial Pest Management',
    'Termite Inspection & Treatment',
    'Rodent Control',
    'Bed Bug Treatment',
    'Wildlife Removal',
    'Preventative Pest Services',
    'Eco-Friendly Solutions'
  ],
  plumbing: [
    'Drain Cleaning',
    'Water Heater Services',
    'Pipe Repair & Replacement',
    'Leak Detection',
    'Fixture Installation',
    'Sewer Line Services',
    'Emergency Plumbing',
    'Bathroom & Kitchen Remodeling'
  ],
  roofing: [
    'Roof Installation',
    'Roof Repair',
    'Roof Inspection',
    'Gutter Installation & Repair',
    'Roof Replacement',
    'Storm Damage Repair',
    'Roof Maintenance',
    'Skylight Installation'
  ]
};
